import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import MainSummary from "../../TripRate/Filters/Summary/MainSummarySection";

interface IProps {
    open: boolean;
    handleClose: () => void;

}
export default function SummaryDialog({ open, handleClose }: IProps) {


    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
            <DialogTitle>
                <Typography variant={"h6"}>Summary</Typography>
            </DialogTitle>
            <DialogContent>
                <MainSummary />
            </DialogContent>
            <DialogActions>
                <Button size={'small'} fullWidth={false} onClick={handleClose}>Close</Button>

            </DialogActions>

        </Dialog>
    )
}